import React, { useCallback } from "react"
import { Button, ButtonProps } from "dash-styled"
import { useDispatch } from "react-redux"
import { push } from "connected-react-router"

export interface NavButtonProps extends Omit<ButtonProps, "onClick"> {
    to: string
    target?: "_blank"
}

/**
 * A link which looks like a button but has `to` instead of `onClick`
 *
 * Note that this component is not available for external links,
 * i.e. links starting with http(s)://
 */
export const NavButton = ({ to, target, ...props }: NavButtonProps) => {
    const dispatch = useDispatch()
    const handleClick = useCallback(() => {
        if (target === "_blank") {
            window.open(to, target, "noopener,noreferrer")
            return
        }

        if (to.match(/^https?:\/\//)) {
            window.location.href = to
            return
        }

        dispatch(push(to))
    }, [dispatch, to, target])

    return (
        <Button
            {...props}
            onClick={props.type !== "anchor" ? handleClick : undefined}
            href={props.type === "anchor" ? to : undefined}
        />
    )
}
